import axiosInstance from "./axiosInstance.js";

/**
 * Base API service class
 * Provides common HTTP methods for all service classes
 */
export class ApiService {
  constructor(baseUrl = "") {
    this.baseUrl = baseUrl;
  }

  // Generic request method
  async request(method, url, data = null, config = {}) {
    const fullUrl = `${this.baseUrl}${url}`;

    const response = await axiosInstance({
      method,
      url: fullUrl,
      data,
      ...config,
    });
    return response;
  }

  // HTTP method helpers
  async get(url, config = {}) {
    return this.request("GET", url, null, config);
  }

  async post(url, data, config = {}) {
    return this.request("POST", url, data, config);
  }

  async put(url, data, config = {}) {
    return this.request("PUT", url, data, config);
  }

  async patch(url, data, config = {}) {
    return this.request("PATCH", url, data, config);
  }

  async delete(url, config = {}) {
    return this.request("DELETE", url, null, config);
  }
}

export default ApiService;
